import { isNil, omitBy } from 'lodash';

import type { EffectParams, ModelConfig, Slicer } from '@swf/core/store';
import { select } from '@swf/core/store';

import * as reducers from './reducers/historicalBets';
import type {
  HistoricalBetState,
  HistoricalSearchBetsQuery,
  RawHistoricalBetsPayload
} from './types/historicalBets';

export const initialState: HistoricalBetState = {
  bets: [],
  isFetching: false,
  isErroneous: false,
  moreAvailable: false
};

export const PAGE_SIZE = 6;

const selectors = (slice: Slicer<HistoricalBetState>) => ({
  isFetching() {
    return slice((state) => state.isFetching);
  },
  isErroneous() {
    return slice((state) => state.isErroneous);
  },
  bets() {
    return slice((state) => state.bets);
  },
  moreAvailable() {
    return slice((state) => state.moreAvailable);
  }
});

const effects = {
  betsRequested: async (
    payload: HistoricalSearchBetsQuery,
    { dispatch, rootState, request }: EffectParams
  ) => {
    try {
      let { pageNumber } = payload;

      if (pageNumber === undefined) {
        pageNumber = Math.floor(select.historicalBets.bets(rootState).length / PAGE_SIZE);
      }

      const cleanedPayload = omitBy<Record<string, string | number>>(
        { ...payload, pageNumber, pageSize: PAGE_SIZE },
        isNil
      );

      const result = await request<RawHistoricalBetsPayload>({
        service: '/api/v1-preview/betHistory',
        http: true,
        body: cleanedPayload
      });

      dispatch.historicalBets.betsLoadedSuccessfully(result.body);
    } catch {
      dispatch.historicalBets.betsLoadedUnsuccessfully();
    }
  }
};

interface HistoricalBetsModel extends ModelConfig<HistoricalBetState> {
  selectors: typeof selectors;
  effects: typeof effects;
  reducers: typeof reducers;
}

const historicalBets: HistoricalBetsModel = {
  state: { ...initialState },
  selectors,
  effects,
  reducers
};

export default historicalBets;
